import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchableDropdownComponent } from './searchable-dropdown.component';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        FormsModule,
        NgSelectModule
    ],
    declarations: [
        SearchableDropdownComponent
    ],
    exports: [
        SearchableDropdownComponent
    ]
})

export class SearchableDropdownModule {
}
